<template>
  <Card class="top">
    <div class="top-header">
      <span>
        本月销售Top10排行榜
      </span>
      
      <!-- <RadioGroup
        v-model="type"
        size="mini"
      >
        <RadioButton label="cost">业绩</RadioButton>
        <RadioButton label="cmplr">完成率</RadioButton>
      </RadioGroup> -->
    </div>

    <div class="top-podium">
      <div class="top-podium-user">
        <Avatar
          class="top-podium-user-2"
          :rank="2"
          :name="top3[1] ? top3[1].username : ''"
          :src="top3[1] ? top3[1].avatar : ''"
        />
        <Avatar
          class="top-podium-user-1"
          :rank="1"
          :name="top3[0] ? top3[0].username : ''"
          :src="top3[0] ? top3[0].avatar : ''"
        />
        <Avatar
          class="top-podium-user-3"
          :rank="3"
          :name="top3[2] ? top3[2].username : ''"
          :src="top3[2] ? top3[2].avatar : ''"
        />
      </div>
      <div class="top-podium-platform">
        <img :src="podium">
        <div class="top-podium-platform-money top-podium-platform-money-1">{{ getValue(0) }}</div>
        <div class="top-podium-platform-money top-podium-platform-money-2">{{ getValue(1) }}</div>
        <div class="top-podium-platform-money top-podium-platform-money-3">{{ getValue(2) }}</div>
      </div>
    </div>

    <div class="top-list">
      <div
        v-for="(item, index) in other"
        :key="index"
        class="top-list-item"
      >
        <div class="top-list-item-rank">{{ index + 4 }}</div>
        <div class="top-list-item-user">
          <img :src="item.avatar">
          <div>{{ item.username }}</div>
        </div>
        <div class="top-list-item-money">{{ getListValue(item) }}</div>
      </div>
    </div>
  </Card>
</template>

<script>
// import { RadioGroup, RadioButton } from 'element-ui';
import accounting from 'accounting';
import { fenToYuan } from '@/common/number/';

import Card from '../Card/Index';
import Avatar from './components/Avatar/Index';

import podium from '@/assets/image/direct/podium.png';

export default {
  components: {
    // RadioGroup,
    // RadioButton,

    Card,
    Avatar,
  },

  props: {
    dataSource: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      type: 'cost',
      podium,
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },

  computed: {
    top3() {
      return this.type === 'cost'
        ? this.costTeamRankingTop3
        : this.cmplrTeamRankingTop3;
    },

    other() {
      return this.type === 'cost'
        ? this.costTeamRankingOther
        : this.cmplrTeamRankingOther;
    },

    costTeamRanking() {
      return this.dataSource.cost_team_ranking || [];
    },

    costTeamRankingTop3() {
      return this.costTeamRanking.slice(0, 3);
    },

    costTeamRankingOther() {
      return this.costTeamRanking.slice(3, 10);
    },

    cmplrTeamRanking() {
      return this.dataSource.cmplr_team_ranking || [];
    },

    cmplrTeamRankingTop3() {
      return this.cmplrTeamRanking.slice(0, 3);
    },

    cmplrTeamRankingOther() {
      return this.cmplrTeamRanking.slice(3, 10);
    },
  },

  methods: {
    getValue(index) {
      if (this.top3[index]) {
        const num = this.top3[index][this.type];
        if (this.type === 'cost') {
          const value = fenToYuan(num);
          return accounting.formatMoney(value, '￥');
        }
        return num;
      }
      return 0;
    },

    getListValue(item) {
      if (this.type === 'cost') {
        const value = fenToYuan(item[this.type]);
        return accounting.formatMoney(value, '￥');
      }
      return item[this.type];
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
  flex-direction: column;
  align-items: center;

  &-header {
    width: 100%;
    font-weight: 600;
    color: rgba(48, 49, 51, 1);
    line-height: 18px;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-podium {
    position: relative;
    margin-top: 30px;
    display: flex;
    align-items: center;
    flex-direction: column;

    &-user {
      display: flex;
      justify-content: space-between;

      &-1 {
        margin: 0 58px;
      }

      &-2 {
        transform: translateY(20px);
      }

      &-3 {
        transform: translateY(32px);
      }
    }

    &-platform {
      width: 462px;
      position: relative;
      margin-top: 12px;

      & > img {
        width: 100%;
      }

      &-money {
        font-size: 14px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 18px;
        position: absolute;
        text-align: center;

        &-1 {
          width: 150px;
          left: 156px;
          top: 45px;
        }

        &-2 {
          width: 130px;
          left: 26px;
          top: 54px;
        }

        &-3 {
          width: 130px;
          left: 306px;
          top: 61px;
        }
      }
    }
  }

  &-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    width: 90%;

    &-item {
      display: flex;
      width: 100%;
      margin-bottom: 16px;
      align-items: center;

      &:last-child {
        margin-bottom: 0;
      }

      &-rank {
        flex: 0 0 90px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(156, 166, 192, 1);
      }

      &-user {
        flex: 0 0 140px;
        display: flex;
        align-items: center;

        & > img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 12px;
        }
      }

      &-money {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        font-size: 18px;
        font-weight: bold;
        color: rgba(47, 158, 255, 1);
        line-height: 16px;
      }
    }
  }
}
</style>